<template>
  <div class="content">
    <div class="header_top">
      <div class="header_in">
        <div>
          <p>欢迎来到智污邦环保服务平台</p>
          <ul>
            <!-- <li>登录</li> -->
            <router-link  target="li" style="cursor: pointer"
              v-if="$store.state.user.userInfo" to="/corporate_account"
              >{{ $store.state.user.userInfo.data.name }}</router-link>
            <router-link v-else target="li" to="/login">登录</router-link>
		      	<router-link v-if="$store.state.user.userInfo == null"   target="li" to="/register">免费注册</router-link>
            <!-- <li>免费注册</li> -->
            <!-- <li>找回密码</li> -->
            <router-link v-if="$store.state.user.userInfo == null" target="li" to="/retrieve">找回密码</router-link>
            <li v-if="$store.state.user.userInfo && $store.state.user.userInfo.type"  style="margin-left:20px;cursor: pointer;" @click.prevent="logOut()">退出登录</li>
          </ul>
        </div>
        <div>
          <ul>
            <!-- <li>快速发布信息</li> -->
            <router-link v-if="$store.state.user.userInfo != null" target="li" to="/demandAdd">快速发布信息</router-link>
            <router-link target="li" to="/platform_entry">入驻平台</router-link>
            <!-- <li>入驻平台</li> -->
            <!-- <li>帮助中心</li> -->
            <router-link target="li" to="/help_center">帮助中心</router-link>
            <!-- <li>个人中心</li> -->
            <router-link v-if="$store.state.user.userInfo == null "  target="li" to="/login">个人中心</router-link>
            <router-link v-else-if="$store.state.user.userInfo.type == 3 "  target="li" to="/corporate_account">个人中心</router-link>
            <router-link v-else target="li" to="/number">个人中心</router-link>
          </ul>
        </div>
      </div>
    </div>
    <div class="header_body">
      <router-link to="/">
        <img class="search_logo" src="../assets/images/logo.jpg" alt=""
      /></router-link>
      <div class="header_serach">
        <div class="search_input">
          <!-- <select name="" id="">
            <option value="产品">产品</option>
            <option value="新闻">新闻</option>
          </select> -->
          <el-select class="select_list" v-model="value" placeholder="" @change="selectChange">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <input type="text" v-model="keyword" @keyup.enter="onSeach()"  placeholder="请输入你要查询的关键字" />
          <button @click.prevent="onSeach()">搜索</button>
          <div class="search_line"></div>
        </div>
        <div class="search_hot">
          <span>热门关键词:</span>
          <ul>
            <!-- <li
            @click.prevent="setKeyword(item)"
            v-for="(item, index) in keywordList"
            :key="index"
            >{{ item.name }}
            </li> -->
            <a  class="search_hot_href" target="_blank" v-for="(item, index) in keywordList" :key="index"  :href="item.link" >{{item.name}}</a>
          </ul>
        </div>
      </div>
      <a v-if="advList.length>0" :href="'//'+advList[0].url" target="_blank"><img class="search_prod" :src="advList[0].image" alt="" /></a>
    </div>
    <div class="header_nav">
      <ul>
        <router-link active-class="active" target="li" to="/" exact
          >首页</router-link
        >

        <router-link
          active-class="active"
          target="li"
          to="/industry_information"
          exact
          >行业资讯</router-link
        >

       

        <router-link
          active-class="active"
          target="li"
          to="/environmental_housekeeper"
          exact
          >环保管家</router-link
        >
          <!-- <router-link active-class="active" target="li" to="/technology" exact
            >环保技术</router-link
          > -->
        <router-link active-class="active" target="li" to="/data_center" exact class="nav-list"
          >
          <div class="nav-child">
            <router-link  to="/technology" 
            >环保技术</router-link
          > </div>
          资料中心</router-link>

        <router-link active-class="active" target="li" to="/supply_demand" exact class="nav-list">          
          <div class="nav-child-supply">
            <router-link to="/jicai_activity_list">集采活动</router-link>
            <br>
            <router-link to="/supply_project">项目信息</router-link>
        </div>供需平台</router-link>

        <router-link
          active-class="active"
          target="li"
          to="/environmental_college"
          exact
          class="nav-list"
        >
          <div class="nav-child">
            <router-link to="/activity_list">活动</router-link>
          </div>

          环学院</router-link>
        <router-link active-class="active" target="li" to="/expert_list" exact
          >环保达人</router-link
        >
      </ul>
    </div>
  </div>
</template>

<script>
import { getAdv } from "@/api/information";
import {toLogin} from "@/utils";
import {getDict} from "@/api/coment"
import {getToken} from '@/utils/auth'
import tipsVue from './tips.vue';
export default {
  name: "headCom",
  data() {
    return {
      value: "产品",
      options: [
        { value: "产品", label: "产品" },
        { value: "企业", label: "企业" },
        { value: "资讯", label: "资讯" },
        { value: "技术", label: "技术" },
        { value: "资料", label: "资料" },
        { value: "供需", label: "供需" },
        { value: "课堂", label: "课堂" },
        { value: "专家", label: "专家" },
        { value: "活动", label: "活动" },
        // { value: "企业", label: "企业" },
      ],
      userShow: false,
      advType:1,
      advList:[],
      keyword:'',
      comType:'产品',
      industry_type:'',
      keywordList:[]
    };
  },
  created() {
    this.getAdv();
    this.getDictList();
    if(getToken() == undefined){
      this.$store.dispatch("user/logout");
    }
  },
  computed: {
    userinfoType() {
      return (
        this.$store.state.user.userInfo && this.$store.state.user.userInfo.type
      );
    },
    dictList(){
       return this.$store.state.industry.list;
     }
  },
  watch: {
    userinfoType: {
      handler(val) {
         this.userShow = (val != "3"?true:false);
         this.type = val;
      },
      immediate: true,
    }
  },
  methods: {
    logOut() {
      localStorage.clear();
      this.$store.dispatch("user/logout");
      toLogin();
      this.$router.push('/login')
    },
    getAdv() {
      getAdv({
        curPage: 1,
        limit: 10,
        type: this.advType,
      }).then(res=>{
	    if(res.code == 0)this.advList = res.page.list;
      })
    },
    //搜索
    onSeach(){
      if(this.comType =="" && this.keyword ==""){
          this.$message({
             message:'搜索条件不能为空',
             type:'info'
          })
      }else if(this.comType =="" && this.keyword !=""){
         this.$message({
             message:'请选择搜索类型',
             type:'info'
          })
      }else{
        switch(this.comType){
           case '产品':
           this.$router.push({
              path:'/searchIndex',
              query:{
                type:this.comType,
                keyword:this.keyword
              }
           });
           break;
           case '资讯':
           this.$router.push({
              path:'/searchIndex',
              query:{
                type:this.comType,
                keyword:this.keyword
              }
           })
           break;
           case '技术':
           this.$router.push({
              path:'/searchIndex',
              query:{
                type:this.comType,
                keyword:this.keyword
              }
           })
           break;
           case '资料':
           this.$router.push({
              path:'/searchIndex',
              query:{
                type:this.comType,
                keyword:this.keyword
              }
           })
           break;
           case '供需':
           this.$router.push({
              path:'/searchIndex',
              query:{
                type:this.comType,
                keyword:this.keyword
              }
           })
           break;
           case '课堂':
           this.$router.push({
              path:'/searchIndex',
              query:{
                type:this.comType,
                keyword:this.keyword
              }
           })
           break;
           case '专家':
           this.$router.push({
              path:'/searchIndex',
              query:{
                type:this.comType,
                keyword:this.keyword
              }
           })
           break;
           case '活动':
           this.$router.push({
              path:'/searchIndex',
              query:{
                type:this.comType,
                keyword:this.keyword
              }
           })
           break;
           case "企业":
            this.$router.push({
              path:'/searchIndex',
              query:{
                type:this.comType,
                keyword:this.keyword
              }
           })
           break;
        }
      }
    },
    selectChange(row){
      this.comType = row;
    },
    getDictList(){
      let params = {code: this.industry_type};
      getDict(params)
        .then((res) => {
          if (res.code == 0) {
            this.keywordList = res.data[5].children;
          }
        })
        .catch((err) => {});
    }
  },
};
</script>

<style scoped lang="less">
.search_hot_href{
  color: #999999 !important;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  margin-right: 10px;
}
.search_hot_href:hover{
  color: #ff7302 !important;
}
.nav-list {
  position: relative;
  z-index: 999;
  &:hover {
    .nav-child {
      display: block;
    }
    .nav-child1 {
      display: block;
    }
    .nav-child-supply {
      display: block;
    }
  }
}
.nav-child {
  transition: all 0.5s;
  width: 100%;
  height: 67px;
  background: #569717;
  position: absolute;
  top: 67px;
  z-index: 666;
  display: none;
}
.nav-child-supply {
  transition: all 0.5s;
  width: 100%;
  height: 134px;
  background: #569717;
  position: absolute;
  top: 67px;
  z-index: 666;
  display: none;
}
.nav-child1 {
  transition: all 0.5s;
  width: 100%;
  height: 67px;
  background: #569717;
  position: absolute;
  top: 133px;
  z-index: 666;
  display: none;
}
.select_list {
  width: 15%;
  /deep/ .el-input__inner {
    height: 53px;
    border-radius: 0;
    border-right: 0;
    border-color: #65b62b;
  }
  /deep/ .el-input.is-focus .el-input__inner {
    border-color: #65b62b !important;
  }
  /deep/ .el-input__inner:focus {
    border-color: #65b62b !important;
  }
}
.header_top {
  width: 100%;
  line-height: 31px;
  background: #f0f0f0;
  .header_in {
    width: 1080px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    // @media (min-width: 1600px) {
    //   width: 60%;
    // }
    div,
    ul {
      display: flex;
      justify-content: space-between;
      p,
      li {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
      p {
        margin-right: 54px;
      }
      li {
        margin: 0 5px;
      }
      a {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        padding-left: 20px;
      }
    }
  }
}
.header_body {
  position: relative;
  width: 1080px;
  margin: 0 auto;
  padding: 35px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // @media (min-width: 1600px) {
  //   width: 60%;
  // }
  .search_logo {
    width: 189px;
    height: 59px;
  }
  .search_prod {
    width: 211px;
    height: 84px;
  }
  .header_serach {
    // position: absolute;
    right: 28%;
    width: 48%;
    .search_input {
      display: flex;
      position: relative;
      select {
        padding-left: 10px;
        border: 1px solid #65b62b;
        border-right: none;
        outline: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        option {
          width: 100px;
          height: 50px;
        }
      }
      input {
        width: 70%;
        border: 1px solid #65b62b;
        border-right: none;
        border-left: none;
        padding: 16px 0;
        padding-left: 16px;
        // @media (min-width: 1600px) {
        //   width: 680px;
        // }
      }
      button {
        width: 15%;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        background: #3bae30;
      }
      .search_line {
        position: absolute;
        width: 1px;
        height: 18px;
        background: #eeeeee;
        top: 50%;
        margin-top: -9px;
        left: 80px;
      }
    }
    .search_hot {
      display: flex;
      margin-top: 9px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      span {
        margin-right: 5px;
      }
      ul {
        display: flex;
        li {
          margin-right: 8px;
          cursor: pointer;
          &:last-of-type {
            margin-right: 0;
          }
        }
      }
    }
  }
}
.header_nav {
  width: 100%;
  height: 67px;
  background: url("../assets/images/bg.jpg") no-repeat center/cover;
  ul {
    display: flex;
    justify-content: space-between;
    width: 1080px;
    line-height: 67px;
    margin: 0 auto;
    // @media (min-width: 1600px) {
    //   width: 60%;
    // }
    a {
      width: 100px;
      font-size: 16px;
      text-align: center;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      transition: 0.5s;
    }
    .active {
      background: rgba(86, 151, 23, 1);
      // position: relative;
      // &::after {
      //   animation: move 0.5s;
      //   position: absolute;
      //   bottom: 0;
      //   display: flex;
      //   content: "";
      //   width: 100%;
      //   height: 2px;
      //   background: #569717;
      // }
    }
  }
}

@keyframes move {
  from {
    width: 0px;
  }
  to {
    width: 100px;
  }
}

@-moz-keyframes move /* Firefox */ {
  from {
    width: 0px;
  }
  to {
    width: 100px;
  }
}

@-webkit-keyframes move /* Safari 和 Chrome */ {
  from {
    width: 0px;
  }
  to {
    width: 100px;
  }
}

@-o-keyframes move /* Opera */ {
  from {
    width: 0px;
  }
  to {
    width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/headCom.vue